/**
 * @author Punit Vajpeyi <punit@wemotiveforge.com>
 */

import React from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Form, Badge, Button, Col, Input, Row, Upload, Typography } from 'antd';
import './UserProfile.css';
import MessageModal from "../../../../utils/components/MessageModal/MessageModal";
import ChangePassword from "../../../Authentication/components/ChangePassword/ChangePassword";
import ConstantMessages from '../../../../utils/Strings';
import Notification from '../../../../utils/Notification';
import UtilHelper from '../../../../utils/UtilHelper';
import {
  deleteUserProfileImage,
  getUserDetailsRequest,
  getUserProfileImage,
  updateUserProfileRequest,
  uploadProfileImage
} from "../../UserApiActions";
import {setPageTitle} from "../../../Dashboard/DashboardActions";
import {signOut, updateProfileImage} from "../../../Authentication/AuthenticationActions";
import MobileNumber from "../../../../utils/components/MobileNumber/MobileNumber";
import {ACTIONS} from '../../../../utils/Constants';
import { LogoutOutlined } from '@ant-design/icons';
import ActivateOrDeactivateUser from '../ActivateOrDeactivateUser/ActivateOrDeactivateUser'
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon';
const FormItem = Form.Item;
const notification = new Notification();

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

class UserProfileForm extends React.Component {

  onCancel = () => {
    window.history.back();
  };
  removeProfileImage = () => {
    this.props.deleteUserProfileImage(this.props.loggedInUser.id).then((res) => {
    }, (error) => {
    });
  };
  updateMobileNumber = (phone, validPhoneNumber) => {
    this.setState({phone, validPhoneNumber});
  };
  handleSubmit = formData => {
    this.setState({formSubmit: true});
    // e.preventDefault();
    // this.props.form.validateFields((err, formData) => {
      // if (this.state.validPhoneNumber) {
        // formData.phone = this.state.phone && this.state.phone.length > 4 ? this.state.phone : '';
        if (formData.phone.charAt(0) !== '+') {
          formData.phone = `+${formData.phone}`
        }
        this.props.updateUserProfile(this.props.loggedInUser.id, formData).then((res) => {
          if (res.hasOwnProperty('phone'))
            this.setState({phone: res.phone});

          //TODO: Show modal instead of sweet notification
          this.refs.messageModal.setState({
            showModal: true,
            title: ConstantMessages.updateUserNotificationTitle,
            message: ConstantMessages.updateUserSuccessMessage,
            showOkButton: true,
            handleOk: () => {
            },
            okText: 'Ok',
            cancelText: 'Cancel'
          });
        }, (error) => {
        });
      // }
    // });
  };

  navigateToChangePassword = () => {
    this.setState({ showChangePasswordModal: true })
    // this.props.history.push(ACTIONS.CHANGE_PASSWORD);
  };

  getAdditionUserDetails = () => {
    this.props.getUserProfileImage(this.props.loggedInUser.id).then(() => {
    }, (error) => {
    });
  };

  constructor(props) {
    super(props);

    this.state = {
      phone: '',
      formSubmit: false,
      validPhoneNumber: true,
      subscriptionPlans: [],
      showChangePasswordModal: false,
      showActivateDeactivateUserModal: false,
    }
  }

  componentWillReceiveProps(nextProps) {

    if (this.props.loggedInUser) {
      if (this.props.loggedInUser.phone !== nextProps.loggedInUser.phone) {
        if (nextProps.loggedInUser.phone !== null)
          this.setState({phone: nextProps.loggedInUser.phone, validPhoneNumber: true});
        else
          this.setState({phone: '', validPhoneNumber: true});
      } else if (this.state.phone === '' && this.props.loggedInUser.phone) {
        if (this.props.loggedInUser.phone !== null)
          this.setState({phone: this.props.loggedInUser.phone, validPhoneNumber: true});
        else
          this.setState({phone: '', validPhoneNumber: true});
      }
    }
  }

  componentDidMount() {

    this.props.getUserDetailsRequest(this.props.loggedInUser.id).then((res) => {
      if (res.hasOwnProperty('phone') && res.phone) {
        this.setState({phone: res.phone}, () => {
          this.getAdditionUserDetails();
        })
      } else {
        this.getAdditionUserDetails();
      }

    }, (error) => {
    });

    this.props.updatePageTitle(this.props.pageTitle, false);
  }

  render() {

    const self = this;

    const uploadOptions = {
      showUploadList: false,

      beforeUpload(file) {
        let allowedFiles = ['image/jpeg', 'image/jpg', 'image/png'];

        let isImageFile = allowedFiles.indexOf(file.type) >= 0;
        if (!isImageFile) {
          notification.show('error', 'Incorrect file format', 'You can only upload file with png/jpg/jpeg extension');
        } else {

          const formData = new FormData();
          formData.append('file', file);

          self.props.uploadProfileImage(formData, self.props.loggedInUser.id).then((res) => {
            getBase64(file, imageUrl => {
              self.props.onProfileImageUpdate(imageUrl);
              notification.show('info', ConstantMessages.imageUploadSuccessful, 'file uploaded successfully');
            });
          }, error => {
            notification.show('error', ConstantMessages.imageUploadFailed, 'file uploaded failed');
          });
        }
        return false;
      }
    };

    // const {getFieldDecorator} = this.props.form;

    const {loggedInUser} = this.props;

    const fieldValidationRules = {
      username: {
        rules: [
          {type: 'email', message: ConstantMessages.enterValidEmailAddress},
          {required: true, whitespace: true, message: ConstantMessages.emailAddressRequired}
        ],
      },
      firstName: {
        rules: [
          { required: true, whitespace: true, message: ConstantMessages.firstNameRequired },
          { max: 50, message: 'Maximum 50 characters allowed' }
        ]
      },
      lastName: {
        rules: [
          { required: true, whitespace: true, message: ConstantMessages.lastNameRequired },
          { max: 50, message: 'Maximum 50 characters allowed' }
        ]
      },
      location: {
        rules: [
          { required: true, whitespace: true, message: ConstantMessages.locationRequired },
          { max: 255, message: 'Maximum 255 characters allowed' }
        ]
      }
    };

    let style = {};

    if (!this.props.currentRole.isSuperAdmin) {
      fieldValidationRules['organization'] = {
        rules: [
          { required: true, whitespace: true, message: ConstantMessages.organizationRequired },
          { max: 255, message: 'Maximum 255 characters allowed.' }
        ]
      }
    } else {
      style = {display: 'none'};
    }

    return (
      <div className="flex-vertical-gap-4">
      <div className="flex-horizontal" style={{ justifyContent: "space-between" }}>
        <Typography.Title level={2} style={{ margin: 0 }}>Account</Typography.Title>
        {/* <Button type="default" onClick={() => this.props.signOut()}>Logout<CustomIcon name="Logout" /></Button> */}
      </div>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <div className="gs-theme__container" style={{ width: '100%', maxWidth: '800px', padding: '24px' }}>
        <Row>
          {/* <Col span={6} className="padding-16 text-align-center">
            <img src={this.props.profileImg} alt="avatar" className="width-200 height-200 userProfile"/>
            <Badge count={"X"} onClick={this.removeProfileImage} className="remove-profile-pic">
            </Badge>

            <div>
              <Upload {...uploadOptions} className="upload-profile-pic">
                <Button>
                  <Icon type="upload"/> Upload Photo
                </Button>
              </Upload>
              <div>
                <i>Note: Allowed files formats png, jpg, jpeg</i>
              </div>
            </div>

            <Button type="primary" ghost className={'change-password'} onClick={this.navigateToChangePassword}>
              Change password
            </Button>
          </Col> */}
          <Col span={24}>
            <Form className="flex-vertical-gap-2" form={this.props.form} layout="vertical" style={{ width: '100%', padding: 0, backgroundColor: 'transparent' }} onFinish={this.handleSubmit} initialValues={{
              username: loggedInUser.username,
              firstName: loggedInUser.firstName,
              lastName: loggedInUser.lastName,
              location: loggedInUser.location,
              phone: loggedInUser.phone,
              organization: loggedInUser.organization !== null ? loggedInUser.organization.name : '',
            }}>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <Form.Item name="firstName" label="First Name" {...fieldValidationRules.firstName }>
                      <Input placeholder="Enter first name" maxLength={50}/>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <Form.Item name="lastName" label="Last Name" {...fieldValidationRules.lastName}>
                      <Input placeholder="Enter last name" maxLength={50}/>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <Form.Item name='username' label="Email address" {...fieldValidationRules.username}>
                      <Input placeholder=""/>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <MobileNumber name="phone" label="Mobile Number" required />
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <Form.Item name="location" label="Location" {...fieldValidationRules.location}>
                      <Input placeholder=""/>
                  </Form.Item>
                </Col>
                <Col style={style} xs={24} sm={24} md={12} lg={12}>
                  <Form.Item name="organization" label="Organization name" {...fieldValidationRules.organization}>
                      <Input placeholder="" disabled={this.props.currentRole.isAnalyst}/>
                  </Form.Item>
                </Col>

                {/* <Col offset={12} span={6} className="padding-16">
                  <div className="blank-div"></div>
                  <FormItem>
                    <Button
                      type="default"
                      htmlType="button"
                      onClick={this.onCancel}
                      className="form-button">
                      Cancel
                    </Button>
                  </FormItem>
                </Col> */}
                {/* <Col span={6} className="padding-16">
                  <div className="blank-div"></div>
                  <FormItem>
                    <Button
                      block
                      type="primary"
                      htmlType="submit"
                      className="form-button">
                      Update
                    </Button>
                    <Button block type="primary" ghost className={'change-password'} onClick={this.navigateToChangePassword}>
                      Change password
                    </Button>
                  </FormItem>
                </Col> */}
              </Row>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <div className="flex-vertical-gap-4 margin-top-2" style={{ alignItems: 'center' }}>
                    <Button block type="primary" htmlType="submit">
                      Save Changes
                      <CustomIcon name="Check" />
                    </Button>
                    <Button block onClick={this.navigateToChangePassword}>
                      Reset Password
                      <CustomIcon name="Reset" />
                    </Button>
                    <Button block onClick={() => this.setState({ showActivateDeactivateUserModal: true })}>
                      Deactivate Account
                      <CustomIcon name="DeleteTrash" />
                    </Button>
                    <Typography.Text type="secondary">Account created {moment(loggedInUser.createdAt).local().format('DD/MM/YYYY')}</Typography.Text>
                  </div>
                </Col>
              </Row>
            </Form>
            <ChangePassword visible={this.state.showChangePasswordModal} onCancel={() => this.setState({ showChangePasswordModal: false })} />
            <ActivateOrDeactivateUser visible={this.state.showActivateDeactivateUserModal} onCancel={() => this.setState({ showActivateDeactivateUserModal: false })} user={loggedInUser} />
          </Col>
        </Row>

        <MessageModal
          ref="messageModal"
        />

      </div>
      </div>
      </div>
    );
  }
}


let UserProfile = (props) => {
  const [form] = Form.useForm();
  return <UserProfileForm form={form} {...props} />;
};

const mapStateToProps = state => {
  return {
    loggedInUser: state.auth.loggedInUser,
    profileImg: state.auth.profileImg,
    currentRole: state.auth.currentRole
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => {
      dispatch(signOut())
    },
    getUserDetailsRequest: (id) => {
      return dispatch(getUserDetailsRequest(id)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    getUserProfileImage: (id) => {
      return dispatch(getUserProfileImage(id)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    deleteUserProfileImage: (id) => {
      return dispatch(deleteUserProfileImage(id)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    updateUserProfile: (id, data) => {
      return dispatch(updateUserProfileRequest(id, data)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    updatePageTitle: (pageTitle, enablePageTitle) => {
      dispatch(setPageTitle(pageTitle, enablePageTitle));
    },

    onProfileImageUpdate: (imageUrl) => {
      dispatch(updateProfileImage(imageUrl));
    },

    uploadProfileImage: (formData, id) => {
      return dispatch(uploadProfileImage(formData, id)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    }
  }
};

UserProfile = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserProfile);

export default UserProfile;
